export const SET_PRO_ACCOUNT_LEFT_BAR_DATA = 'SET_PRO_ACCOUNT_LEFT_BAR_DATA';
export const SET_PRO_ACCOUNT_STATISTIC = 'SET_PRO_ACCOUNT_STATISTIC';
export const SET_PRO_PHONES_ASSIGNMENT = 'SET_PRO_PHONES_ASSIGNMENT';
export const SET_PRO_SELLER_PAGE_DATA = 'SET_PRO_SELLER_PAGE_DATA';
export const SET_BUSINESS_FEATURES_DATA = 'SET_PRO_SELLER_DATA';
export const SET_BUSINESS_FEATURES_DATA_BY_ID = 'SET_BUSINESS_FEATURES_DATA_BY_ID';
